import React from 'react'

import Region from 'models/Region'
import Translation from 'models/Translation'
import Topic from 'models/Topic'
import Market from 'models/Market'
import Footprint from 'models/Footprint'
import Locale from 'models/Locale'

interface AppInfo {
    locales: Locale[],
    locale: string
    text: Translation
    footprint: Footprint | undefined
    markets: Market[]
    regionFilter: Region[]
    regionFilterIds: number[]
    topics: Topic[],
    onNavigate: (page: number) => void
}

const appInfo: AppInfo = {
    locales: [],
    locale: '',
    text: {},
    footprint: undefined,
    markets: [],
    regionFilter: [],
    regionFilterIds: [],
    topics: [],
    onNavigate: () => {}
}

const AppContext = React.createContext(appInfo)

export default AppContext
